import Contactform from "./Contactform"

export const Contactmain = () => {
  return (
    <>
     <Contactform />
    </>
  )
}
